import { useListStore } from '../../hooks';
import { EnvironmentListView } from '../../components/EnvironmentListView';

export const EnvironmentList = () => {
  const { releaseEnvironments, onOpenModal, componentList } = useListStore();

  return (
    <EnvironmentListView
      listItems={releaseEnvironments}
      handleEditOpenModal={onOpenModal}
      componentList={componentList}
    />
  );
};
